import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const TermsAcceptance = ({ acceptedTerms, onTermsChange, errors, currentLanguage }) => {
  const content = {
    fr: {
      termsTitle: 'Conditions d\'utilisation',
      termsText: 'J\'accepte les conditions générales d\'utilisation et la politique de confidentialité',
      islamicTitle: 'Conformité islamique',
      islamicText: 'Je confirme que mon agence respecte les principes islamiques et les réglementations saoudiennes pour les pèlerinages',
      saudiTitle: 'Réglementation saoudienne',
      saudiText: 'Je m\'engage à respecter toutes les réglementations du Ministère du Hajj et de la Omra d\'Arabie Saoudite',
      dataTitle: 'Protection des données',
      dataText: 'J\'accepte le traitement des données conformément au RGPD et aux lois marocaines sur la protection des données'
    },
    ar: {
      termsTitle: 'شروط الاستخدام',
      termsText: 'أوافق على الشروط والأحكام العامة وسياسة الخصوصية',
      islamicTitle: 'الامتثال الإسلامي',
      islamicText: 'أؤكد أن وكالتي تحترم المبادئ الإسلامية واللوائح السعودية للحج والعمرة',
      saudiTitle: 'اللوائح السعودية',
      saudiText: 'ألتزم باحترام جميع لوائح وزارة الحج والعمرة في المملكة العربية السعودية',
      dataTitle: 'حماية البيانات',
      dataText: 'أوافق على معالجة البيانات وفقًا للائحة العامة لحماية البيانات والقوانين المغربية لحماية البيانات'
    }
  };

  const text = content?.[currentLanguage];

  const terms = [
    {
      id: 'terms',
      title: text?.termsTitle,
      text: text?.termsText,
      icon: 'FileText',
      required: true
    },
    {
      id: 'islamic',
      title: text?.islamicTitle,
      text: text?.islamicText,
      icon: 'Star',
      required: true
    },
    {
      id: 'saudi',
      title: text?.saudiTitle,
      text: text?.saudiText,
      icon: 'Shield',
      required: true
    },
    {
      id: 'data',
      title: text?.dataTitle,
      text: text?.dataText,
      icon: 'Lock',
      required: true
    }
  ];

  return (
    <div className="space-y-4 md:space-y-6">
      {terms?.map((term) => (
        <div
          key={term?.id}
          className="border border-border rounded-xl p-4 md:p-6 hover:border-primary/50 transition-smooth"
        >
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center">
              <Icon name={term?.icon} size={20} className="text-primary" />
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="text-base md:text-lg font-semibold text-foreground mb-2">
                {term?.title}
              </h4>
              <Checkbox
                label={term?.text}
                checked={acceptedTerms?.[term?.id] || false}
                onChange={(e) => onTermsChange(term?.id, e?.target?.checked)}
                error={errors?.[term?.id]}
                required={term?.required}
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TermsAcceptance;